import { createSelector } from 'reselect';

import { getRouterPrevLocation } from '@shared/selectors';
import { generateURL } from '@utils/url';

const getPrevLocationFullUrl = createSelector(getRouterPrevLocation, location =>
  location ? generateURL(location) : '',
);

export default getPrevLocationFullUrl;
